import { useDialog } from '@theme/use-dialog'

function warnMissingTriggerProduct(trigger) {
  if (!(window.Shopify?.designMode || window.__THEME_DEV__)) {
    return
  }

  // biome-ignore lint/suspicious/noConsole: dev-only trigger contract diagnostics
  console.warn(
    `[drawer-notify] trigger <${trigger.tagName.toLowerCase()}> has data-notify-product="${trigger.dataset.notifyProduct}", expected a non-empty product title`
  )
}

class NotifyDrawerComponent extends useDialog {
  connectedCallback() {
    super.connectedCallback()

    if (this.refs.openOnLoad) {
      this.showDialog()
    }
  }

  open(event) {
    this.#applyTriggerProduct(event?.target)
    super.open()
  }

  #applyTriggerProduct(trigger) {
    if (!(trigger instanceof HTMLElement)) {
      return
    }

    const { notifyProduct: productTitle, notifyUrl: productUrl } =
      trigger.dataset

    if (!productTitle) {
      warnMissingTriggerProduct(trigger)
      return
    }

    const { notifyBody, notifyProduct } = this.refs

    if (notifyProduct) {
      notifyProduct.textContent = productTitle
    }

    if (!notifyBody) {
      return
    }

    const alertLabel = notifyBody.defaultValue
    notifyBody.value = productUrl
      ? `${alertLabel} — ${productTitle} (${productUrl})`
      : `${alertLabel} — ${productTitle}`
  }
}

if (!customElements.get('ui-drawer-notify')) {
  customElements.define('ui-drawer-notify', NotifyDrawerComponent)
}
